export function isEmpty(boolean){
	return {
		type: "IS_EMPTY",
		payload: boolean
	}
}

export function isEmailValid(boolean){
	return {
		type: "IS_EMAIL_VALID",
		payload: boolean
	}
}

export function hasDuplicatedEmail(boolean){
	return {
		type: "HAS_DUPLICATED_EMAIL",
		payload: boolean
	}
}

export function selectedCollaboratorIndex(int){
	return {
		type: "SELECTED_COLLABORATOR_INDEX",
		payload: int
	}
}